module.exports = __webpack_public_path__ + "static/media/ae.9fd1fcbf.svg";